<template>
  <div>
    <div class="need-text" :class="is_show?'show':'hide'" ref="desc">
      <div ref="text">{{text}}</div>
    </div>
    <el-button type="text" v-if="has_more" @click="showMore">
      {{btn_text}}
      <i :class="btn_icon" class="el-icon--right"></i>
    </el-button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      is_show: false,
      has_more: false,
      text_height: 108
    };
  },
  props: {
    text: {
      default: "",
      typs: "String"
    }
  },
  computed: {
    btn_text () {
      return this.is_show === true ? "收起" : "更多";
    },
    btn_icon () {
      return this.is_show === false
        ? "el-icon-caret-bottom"
        : "el-icon-caret-top";
    },
  },
  mounted () {
    this.text_height = this.$refs.text.getBoundingClientRect().height;
    this.text_height > 108 && (this.has_more = true);
  },
  methods: {
    showMore () {
      this.is_show = !this.is_show;
      this.$refs.desc.scrollTop = 0;
    }
  }
};
</script>
<style lang="less" scoped>
.need-text {
  // padding-top: 20px;
  height: 100px;
  font-size: 24px;
  font-weight: 500;
  // color: #545b61;
  color: #808992;
  letter-spacing: 1px;
  overflow-y: scroll;
  &.hide {
    position: relative;
    line-height: 1.5;
    // max-height: 90px;
    overflow: hidden;
    // &::after {
    //   content: "...";
    //   position: absolute;
    //   bottom: 0;
    //   right: -1px;
    //   padding-left: 30px;
    //   background: -webkit-linear-gradient(left, transparent, #fff 50%);
    //   background: -o-linear-gradient(right, transparent, #fff 50%);
    //   background: -moz-linear-gradient(right, transparent, #fff 50%);
    //   background: linear-gradient(to right, transparent, #fff 50%);
    // }
  }
}
.el-button {
  font-size: 28px;
  font-weight: 500;
  color: #1162d1;
  /deep/ span {
    display: flex;
    align-items: center;
    .el-icon--right {
      margin-left: 9px;
      font-size: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/bizInfo/component/TextBox.vue